import React from 'react';
import BaseSimplePage from "../BaseSimplePage/BaseSimplePage";
import VisitTypesItemForm from "./VisitTypesItemForm";

const VisitTypesPage = ({isAddSubMode}) => {

    return (
        <BaseSimplePage
            isAddSubMode={isAddSubMode}
            modeApiName1="visit_type"
            modeApiName2="visit_types"
            ItemFormComponent={VisitTypesItemForm}
        />
    );
};

export default VisitTypesPage;